'use client';

import { createContext } from 'use-context-selector';
import type {
  SurfaceMessagingStatus,
  SurfaceMessagingValue,
} from '@frameio/connected-surfaces-core/messaging';

export type ConnectedSurfaceContextValue = SurfaceMessagingValue & {
  /**
   * Is Drive currently open and connected
   */
  isDriveConnected: boolean;
  messagingStatus: SurfaceMessagingStatus;
};

export const ConnectedSurfacesContext =
  createContext<ConnectedSurfaceContextValue>({
    isDriveConnected: false,
    messagingStatus: { readySurfaces: [], sessionKey: null },
    sendSurfaceMessage: () =>
      Promise.reject(new Error('ConnectedSurfacesContextProvider not mounted')),
    sendSurfaceRequest: () =>
      Promise.reject(new Error('ConnectedSurfacesContextProvider not mounted')),
    subscribeSurfaceMessage: () => {
      throw new Error('ConnectedSurfacesContextProvider not mounted');
    },
  });
